import { NOTIFICATION_MESSAGES_REQUEST, NOTIFICATION_MESSAGES_COMPLETE, NOTIFICATION_STATES_REQUEST, NOTIFICATION_STATES_SAVE,
	NOTIFICATION_MESSAGES_FETCH, NOTIFICATION_MESSAGES_FAIL, NOTIFICATION_MESSAGES_CLEAR, NOTIFICATION_TYPES_FETCH } from "../store/config";

const notificationMessagesInit = {
	isFetching: false,
	list: [],
	edit: {
		states:[],
		entity:{
			isFetching:false,
			id:1
		}
	},
	notifications_types: [],
	permissions:[],
	types: [],
	error: undefined,
	timestamp: undefined
}

const notification_messages = (state = notificationMessagesInit, action) => {
	switch (action.type){
		case NOTIFICATION_MESSAGES_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case NOTIFICATION_MESSAGES_COMPLETE:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case NOTIFICATION_STATES_REQUEST:
			return {
				...state,
				edit:{
					...state.edit,
					entity:{
						...state.edit.entity,
						isFetching: action.isFetching,
					}
				},
				timestamp: action.timestamp
			}
		case NOTIFICATION_STATES_SAVE:
			return {
				...state,
				edit:{
					...state.edit,
					entity:{
						...state.edit.entity,
						isFetching: action.isFetching,
					}
				},
				timestamp: action.timestamp
			}
		case NOTIFICATION_MESSAGES_FETCH:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload.list,
				edit: {
					...state.edit,
					states: action.payload.states,
					finished: action.payload.finished
				},
				notifications_types: action.payload.notifications_types,
				permissions: action.payload.permissions,
				timestamp: action.timestamp
			}
		case NOTIFICATION_MESSAGES_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		case NOTIFICATION_MESSAGES_CLEAR:
			return {
				...state,
				list: [],
				edit: {
					states:[],
					entity:{
						isFetching:false,
						id:1
					}
				},
				notifications_types: [],
				permissions:[],
				timestamp: action.timestamp
			}
		case NOTIFICATION_TYPES_FETCH:
			return {
				...state,
				isFetching: action.isFetching,
				types: action.payload,
				timestamp: action.timestamp
			}
		default:
			return {
				...state
			}
	}
}

export default notification_messages;


// WEBPACK FOOTER //
// ./src/reducers/notification_messages.js